import { OrganizationCountry } from "../enums/country";
import { isQuebec, resolveRegionCode } from "../region";
export const showProudOfCanada = (country) => {
    return country === OrganizationCountry.Canada;
};
export const isQuebecOrganization = (country, region) => {
    return isQuebec(country, resolveRegionCode(country, region));
};
